import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { Layout } from './components/layout/Layout';
import { trackPageView } from './lib/analytics';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { CareersPage } from './pages/CareersPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { TrialPage } from './pages/TrialPage';
import { PlatformPage } from './pages/PlatformPage';
import { LighthousePage } from './pages/LighthousePage';
import { NaicChecklistPage } from './pages/lighthouse/NaicChecklistPage';
import { StudioPage } from './pages/StudioPage';
import { ConsolePage } from './pages/ConsolePage';
import { TrustPage } from './pages/TrustPage';
import { ClaimsPage } from './pages/ClaimsPage';
import { UnderwritingPage } from './pages/UnderwritingPage';
import { EuAiActClassifierPage } from './pages/tools/EuAiActClassifierPage';
import { NotFoundPage } from './pages/NotFoundPage';

// Track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <PageTracker />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/download" element={<Navigate to="/trial" replace />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/waitlist" element={<Navigate to="/trial" replace />} />
            <Route path="/trial" element={<TrialPage />} />
            <Route path="/platform" element={<PlatformPage />} />
            <Route path="/lighthouse" element={<LighthousePage />} />
            <Route path="/lighthouse/naic-checklist" element={<NaicChecklistPage />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/console" element={<ConsolePage />} />
            <Route path="/trust" element={<TrustPage />} />
            <Route path="/claims" element={<ClaimsPage />} />
            <Route path="/underwriting" element={<UnderwritingPage />} />
            <Route path="/tools/eu-ai-act-classifier" element={<EuAiActClassifierPage />} />
            <Route
              path="/tools/eu-ai-act-classifier/result/:hash"
              element={<EuAiActClassifierPage />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
